

























import {Vue, Component, Prop} from 'vue-property-decorator'
import NetworkTag from '@/components/NetworkTag.vue'

@Component({
  components: {NetworkTag},
})
export default class ConnectWalletMenu extends Vue {
  @Prop({type: Boolean, required: true}) isMenuActive!: boolean
  @Prop({type: String, required: true}) blockchainTagName!: string
  @Prop({type: String, required: true}) title!: string

  onSelectMenu() {
    this.$emit('menu-selected')
  }
}
